import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./styles.css";
export default function DemoAddFooter({ style }) {
  return (
    <>
      <Container
        fluid
        className="demo_ad_footer_container"
        style={{
          backgroundImage: `url('/landing/ads_fake_long.png')`,
          ...style,
        }}
      ></Container>
    </>
  );
}
